import React from 'react';
import ReactMarkdown from 'react-markdown';
import DOMPurify from 'dompurify';

const AIResponse = ({ response }) => {
  const { type, content } = response;

  if (type === 'table') {
    const sanitizedHtml = DOMPurify.sanitize(content);
    return (
      <div 
        className="table-container"
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }} 
      />
    );
  }

  return (
    <div className={`ai-response ${type}`}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default AIResponse; 